import React, { memo } from 'react';
import type { FunctionComponent } from 'react';
import './CancelWithModal.scss';
import { Modal, useModal } from '@shared-components';

import { Button, ModalTemplate } from '@web-components-proxy';

interface CancelWithModalProps {
	confirmAction: () => void;
}

export const CancelWithModal: FunctionComponent<CancelWithModalProps> = memo(({ confirmAction }) => {
	const { isOpen, openModal, closeModal } = useModal();

	return (
		<>
			<span onClick={openModal} className="cancel-with-modal">
				Cancel
			</span>
			<Modal isOpen={isOpen} onCasClosed={closeModal}>
				<ModalTemplate mode="warning">
					<p slot="header-title">Cancel Session?</p>
					<p className="modal-content">The session for this user will be canceled.</p>
					<Button onCasClick={closeModal} slot="footer-content" design="secondary" size="medium">
						No, keep it
					</Button>
					<Button onCasClick={confirmAction} slot="footer-content" design="primary" size="medium">
						Yes, cancel
					</Button>
				</ModalTemplate>
			</Modal>
		</>
	);
});
